(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mellow-customer-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.videoCarouselReady === 'true') return;

      const track = section.querySelector('[data-video-track]');
      const cards = Array.from(section.querySelectorAll('[data-video-card]'));
      const previous = section.querySelector('[data-video-previous]');
      const next = section.querySelector('[data-video-next]');
      const shouldAutoplay = section.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      if (!track || cards.length === 0) return;
      section.dataset.videoCarouselReady = 'true';

      let isDragging = false;
      let didDrag = false;
      let suppressClick = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartScrollLeft = 0;
      let touchStartTime = 0;
      let touchGesture;
      let scrollTimer;
      let isSectionVisible = false;
      let userPausedCard;

      const createLoopClone = (card) => {
        const clone = card.cloneNode(true);
        clone.removeAttribute('data-video-card');
        clone.setAttribute('data-video-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea, video').forEach((element) => element.setAttribute('tabindex', '-1'));
        const cloneVideo = clone.querySelector('video');
        if (cloneVideo) {
          cloneVideo.muted = true;
          cloneVideo.preload = 'none';
        }
        return clone;
      };

      const beforeClones = document.createDocumentFragment();
      const afterClones = document.createDocumentFragment();
      cards.forEach((card) => {
        beforeClones.appendChild(createLoopClone(card));
        afterClones.appendChild(createLoopClone(card));
      });
      track.prepend(beforeClones);
      track.append(afterClones);

      const getScrollStep = () => {
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return cards[0].offsetWidth + gap;
      };

      const getCenteredScrollLeft = (card) => card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;

      const getLoopMetrics = () => {
        return {
          start: getCenteredScrollLeft(cards[0]),
          width: getScrollStep() * cards.length
        };
      };

      const normalizeLoopPosition = () => {
        const metrics = getLoopMetrics();
        let destination = track.scrollLeft;

        while (destination >= metrics.start + metrics.width - 1) destination -= metrics.width;
        while (destination < metrics.start - 1) destination += metrics.width;

        if (Math.abs(destination - track.scrollLeft) > 1) {
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = destination;
          track.getBoundingClientRect();
          track.style.scrollBehavior = '';
        }
      };

      const updateCard = (card) => {
        const video = card.querySelector('video');
        const playButton = card.querySelector('[data-video-play]');
        const muteButton = card.querySelector('[data-video-mute]');
        if (!video) return;

        card.classList.toggle('is-playing', !video.paused);
        card.classList.toggle('is-muted', video.muted);
        if (playButton) playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        if (muteButton) muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      };

      const pauseOthers = (activeVideo) => {
        cards.forEach((card) => {
          const video = card.querySelector('video');
          if (video && video !== activeVideo) video.pause();
        });
      };

      const pauseAll = () => pauseOthers();

      const setActiveCard = (activeCard) => {
        cards.forEach((card) => card.classList.toggle('is-active', card === activeCard));
      };

      const findCenteredCard = () => {
        const trackRect = track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let closestCard;
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          const visible = Math.min(rect.right, trackRect.right) - Math.max(rect.left, trackRect.left);
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (visible > rect.width * 0.35 && distance < closestDistance) {
            closestCard = card;
            closestDistance = distance;
          }
        });

        return closestCard;
      };

      const playCenteredVideo = () => {
        const closestCard = findCenteredCard();
        if (!closestCard) return;
        setActiveCard(closestCard);

        if (userPausedCard === closestCard) {
          pauseAll();
          return;
        }

        userPausedCard = undefined;

        if (!shouldAutoplay || !isSectionVisible) return;
        const activeVideo = closestCard.querySelector('video');
        if (!activeVideo) return;
        pauseOthers(activeVideo);
        activeVideo.play().catch(() => {
          activeVideo.muted = true;
          updateCard(closestCard);
          activeVideo.play().catch(() => {});
        });
      };

      const centerCard = (card, behavior = 'smooth') => {
        track.scrollTo({ left: getCenteredScrollLeft(card), behavior });
      };

      const activateCard = (card, toggleIfPlaying = false) => {
        const video = card.querySelector('video');
        if (!video) return;

        const wasActive = card.classList.contains('is-active');
        centerCard(card);
        setActiveCard(card);
        pauseOthers(video);

        if (toggleIfPlaying && wasActive && !video.paused) {
          userPausedCard = card;
          video.pause();
          return;
        }

        userPausedCard = undefined;
        video.play().catch(() => {
          video.muted = true;
          updateCard(card);
          video.play().catch(() => {});
        });
      };

      const settleCarousel = () => {
        if (isDragging) return;
        normalizeLoopPosition();
        window.requestAnimationFrame(playCenteredVideo);
      };

      const queueSettle = (delay = 180) => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(settleCarousel, delay);
      };

      const scrollOne = (direction) => {
        normalizeLoopPosition();
        track.scrollBy({ left: direction * getScrollStep(), behavior: 'smooth' });
        queueSettle();
      };

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const muteButton = card.querySelector('[data-video-mute]');
        if (!video) return;

        video.loop = false;

        card.addEventListener('click', (event) => {
          if (event.target.closest('[data-video-mute]')) return;
          const toggleIfPlaying = Boolean(event.target.closest('[data-video-play], video'));
          activateCard(card, toggleIfPlaying);
        });
        muteButton?.addEventListener('click', (event) => {
          event.stopPropagation();
          video.muted = !video.muted;
          updateCard(card);
        });
        video.addEventListener('play', () => updateCard(card));
        video.addEventListener('pause', () => updateCard(card));
        video.addEventListener('volumechange', () => updateCard(card));
        video.addEventListener('ended', () => {
          if (card.classList.contains('is-active')) scrollOne(1);
        });
        updateCard(card);
      });

      previous?.addEventListener('click', () => scrollOne(-1));
      next?.addEventListener('click', () => scrollOne(1));

      section.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-video-card]');
        if (card && section.contains(card)) activateCard(card);
      });

      track.addEventListener('pointerdown', (event) => {
        if (mobileQuery.matches && event.pointerType === 'touch') return;
        if (event.button !== 0 || event.target.closest('button, a, input, select, textarea')) return;
        isDragging = true;
        didDrag = false;
        dragStartX = event.clientX;
        dragStartScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.style.scrollBehavior = 'auto';
        track.setPointerCapture?.(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        const delta = event.clientX - dragStartX;
        if (Math.abs(delta) > 4) didDrag = true;
        if (!didDrag) return;
        event.preventDefault();
        track.scrollLeft = dragStartScrollLeft - delta;
      });

      const finishDrag = (event) => {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        track.style.scrollBehavior = '';
        try {
          track.releasePointerCapture?.(event.pointerId);
        } catch (error) {}
        if (didDrag) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
          queueSettle(80);
        }
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);

      track.addEventListener('touchstart', (event) => {
        if (!mobileQuery.matches || event.touches.length !== 1) return;
        normalizeLoopPosition();
        window.clearTimeout(scrollTimer);
        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartScrollLeft = track.scrollLeft;
        touchStartTime = performance.now();
        touchGesture = undefined;
      }, { passive: true, capture: true });

      track.addEventListener('touchmove', (event) => {
        if (!mobileQuery.matches || event.touches.length !== 1) return;
        const touch = event.touches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (!touchGesture) {
          if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 8) return;
          touchGesture = Math.abs(deltaX) > Math.abs(deltaY) * 1.1 ? 'horizontal' : 'vertical';

          if (touchGesture === 'horizontal') {
            isDragging = true;
            track.classList.add('is-dragging');
            track.style.scrollBehavior = 'auto';
            pauseAll();
          }
        }

        if (touchGesture !== 'horizontal') return;
        event.preventDefault();
        track.scrollLeft = touchStartScrollLeft - deltaX;
      }, { passive: false, capture: true });

      const finishTouchSwipe = (event, cancelled = false) => {
        if (!mobileQuery.matches || touchGesture !== 'horizontal') {
          touchGesture = undefined;
          return;
        }

        const touch = event.changedTouches[0];
        const deltaX = touch ? touch.clientX - touchStartX : 0;
        const elapsed = Math.max(performance.now() - touchStartTime, 1);
        const velocity = Math.abs(deltaX) / elapsed;
        const shouldAdvance = !cancelled && (Math.abs(deltaX) >= 34 || (Math.abs(deltaX) >= 18 && velocity >= 0.35));
        const direction = deltaX < 0 ? 1 : -1;
        const destination = shouldAdvance ? touchStartScrollLeft + direction * getScrollStep() : touchStartScrollLeft;

        isDragging = false;
        track.classList.remove('is-dragging');
        track.style.scrollBehavior = '';
        touchGesture = undefined;
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 450);
        track.scrollTo({ left: destination, behavior: 'smooth' });
        queueSettle(120);
      };

      track.addEventListener('touchend', (event) => finishTouchSwipe(event), { capture: true });
      track.addEventListener('touchcancel', (event) => finishTouchSwipe(event, true), { capture: true });
      track.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);

      track.addEventListener('scroll', () => queueSettle(), { passive: true });

      const visibilityObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const wasVisible = isSectionVisible;
        isSectionVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;

        if (!isSectionVisible) {
          pauseAll();
          return;
        }

        if (!wasVisible && shouldAutoplay) {
          const activeCard = cards.find((card) => card.classList.contains('is-active')) || findCenteredCard();
          const activeVideo = activeCard?.querySelector('video');
          if (activeVideo) activeVideo.muted = true;
          window.requestAnimationFrame(playCenteredVideo);
        }
      }, { threshold: [0, 0.25] });

      visibilityObserver.observe(section);

      window.requestAnimationFrame(() => {
        const metrics = getLoopMetrics();
        const initialIndex = Math.floor(cards.length / 2);
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = metrics.start + getScrollStep() * initialIndex;
        track.getBoundingClientRect();
        track.style.scrollBehavior = '';
        window.requestAnimationFrame(playCenteredVideo);
      });
    };

    document.querySelectorAll('[data-mellow-customer-videos]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-mellow-customer-videos]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellow-promo-benefits-bar"] && !Shopify.designMode) return;
  try {
    
  class MellowPromoBenefits extends HTMLElement {
    connectedCallback() {
      this.setupCountdown();
      this.setupBenefitsCarousel();
    }

    setupCountdown() {
      const countdown = this.querySelector('[data-countdown]');
      const endAt = Date.parse(this.dataset.countdownEnd || '');

      if (!countdown || Number.isNaN(endAt)) return;

      const values = countdown.querySelector('[data-countdown-values]');
      const complete = countdown.querySelector('[data-countdown-complete]');
      const hours = countdown.querySelector('[data-countdown-hours]');
      const minutes = countdown.querySelector('[data-countdown-minutes]');
      const seconds = countdown.querySelector('[data-countdown-seconds]');

      const update = () => {
        const remaining = endAt - Date.now();

        if (remaining <= 0) {
          window.clearInterval(this.countdownTimer);
          values.hidden = true;
          if (complete && complete.textContent.trim()) {
            complete.hidden = false;
          } else {
            countdown.hidden = true;
          }
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        hours.textContent = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      };

      update();
      this.countdownTimer = window.setInterval(update, 1000);
    }

    setupBenefitsCarousel() {
      this.benefitsViewport = this.querySelector('[data-benefits-viewport]');
      this.benefitSlides = Array.from(this.querySelectorAll('[data-benefit-slide]'));
      this.previousBenefitButton = this.querySelector('[data-benefits-previous]');
      this.nextBenefitButton = this.querySelector('[data-benefits-next]');

      if (!this.benefitsViewport || this.benefitSlides.length < 2 || !this.previousBenefitButton || !this.nextBenefitButton) return;

      this.showPreviousBenefit = () => this.moveBenefit(-1);
      this.showNextBenefit = () => this.moveBenefit(1);
      this.previousBenefitButton.addEventListener('click', this.showPreviousBenefit);
      this.nextBenefitButton.addEventListener('click', this.showNextBenefit);
    }

    moveBenefit(direction) {
      const currentLeft = this.benefitsViewport.scrollLeft;
      let currentIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.benefitSlides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - currentLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          currentIndex = index;
        }
      });

      const targetIndex = (currentIndex + direction + this.benefitSlides.length) % this.benefitSlides.length;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.benefitsViewport.scrollTo({
        left: this.benefitSlides[targetIndex].offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    disconnectedCallback() {
      window.clearInterval(this.countdownTimer);
      this.previousBenefitButton?.removeEventListener('click', this.showPreviousBenefit);
      this.nextBenefitButton?.removeEventListener('click', this.showNextBenefit);
    }
  }

  if (!customElements.get('mellow-promo-benefits')) {
    customElements.define('mellow-promo-benefits', MellowPromoBenefits);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellow-social-proof"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.socialProofReady === 'true') return;
      section.dataset.socialProofReady = 'true';

      const cards = Array.from(section.querySelectorAll('[data-social-video-card]'));

      const updateCard = (card, video) => {
        card.classList.toggle('is-playing', !video.paused);
      };

      cards.forEach((card) => {
        const video = card.querySelector('video');
        const toggle = card.querySelector('[data-social-video-toggle]');
        if (!video || !toggle) return;

        toggle.addEventListener('click', () => {
          if (video.paused) {
            cards.forEach((otherCard) => {
              const otherVideo = otherCard.querySelector('video');
              if (otherVideo && otherVideo !== video) otherVideo.pause();
            });
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', () => updateCard(card, video));
        video.addEventListener('pause', () => updateCard(card, video));
        video.addEventListener('ended', () => updateCard(card, video));
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-mellow-social-proof]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellow-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMellowTestimonials = (section) => {
    if (!section || section.dataset.mellowTestimonialsReady === 'true') return;

    const track = section.querySelector('[data-mellow-testimonials-track]');
    const previousButton = section.querySelector('[data-mellow-testimonials-previous]');
    const nextButton = section.querySelector('[data-mellow-testimonials-next]');

    if (!track || !previousButton || !nextButton) return;

    section.dataset.mellowTestimonialsReady = 'true';

    const hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = hasReducedMotion ? 'auto' : 'smooth';
    const originalCards = Array.from(track.querySelectorAll('.mellow-testimonials__card'));
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let hasMobileLoop = false;
    let normalizeTimer;

    const cardStep = () => {
      const card = track.querySelector('.mellow-testimonials__card');
      if (!card) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const hasOverflow = hasMobileLoop || track.scrollWidth > track.clientWidth + 2;
      previousButton.hidden = !hasOverflow;
      nextButton.hidden = !hasOverflow;
    };

    const jumpTo = (left) => {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      track.getBoundingClientRect();
      track.style.scrollBehavior = '';
    };

    const normalizeMobileLoop = () => {
      if (!hasMobileLoop) return;

      const step = cardStep();
      const cycleWidth = step * originalCards.length;
      const cycleStart = cycleWidth;
      let destination = track.scrollLeft;

      while (destination < cycleStart - step * 0.5) {
        destination += cycleWidth;
      }

      while (destination >= cycleStart + cycleWidth - step * 0.5) {
        destination -= cycleWidth;
      }

      if (Math.abs(destination - track.scrollLeft) > 1) {
        jumpTo(destination);
      }
    };

    const queueNormalize = () => {
      window.clearTimeout(normalizeTimer);
      normalizeTimer = window.setTimeout(normalizeMobileLoop, 140);
    };

    const createLoopClone = (card) => {
      const clone = card.cloneNode(true);
      clone.classList.add('mellow-testimonials__card--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      return clone;
    };

    const setupMobileLoop = () => {
      window.clearTimeout(normalizeTimer);
      track.querySelectorAll('.mellow-testimonials__card--clone').forEach((clone) => clone.remove());
      hasMobileLoop = mobileQuery.matches && originalCards.length > 1;

      if (!hasMobileLoop) {
        jumpTo(0);
        updateControls();
        return;
      }

      const precedingCycle = document.createDocumentFragment();
      const followingCycle = document.createDocumentFragment();

      originalCards.forEach((card) => {
        precedingCycle.appendChild(createLoopClone(card));
        followingCycle.appendChild(createLoopClone(card));
      });

      track.prepend(precedingCycle);
      track.append(followingCycle);
      window.requestAnimationFrame(() => {
        jumpTo(cardStep() * originalCards.length);
        updateControls();
      });
    };

    track.addEventListener('scroll', queueNormalize, { passive: true });
    track.addEventListener('scrollend', normalizeMobileLoop);
    mobileQuery.addEventListener('change', setupMobileLoop);
    setupMobileLoop();

    const move = (direction) => {
      if (hasMobileLoop) {
        track.scrollBy({ left: cardStep() * direction, behavior });
        queueNormalize();
        return;
      }

      const isAtStart = track.scrollLeft <= 2;
      const isAtEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

      if (direction < 0 && isAtStart) {
        track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior });
        return;
      }

      if (direction > 0 && isAtEnd) {
        track.scrollTo({ left: 0, behavior });
        return;
      }

      track.scrollBy({ left: cardStep() * direction, behavior });
    };

    previousButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));

    const resizeObserver = new ResizeObserver(updateControls);
    resizeObserver.observe(track);
    updateControls();
    };

    document.querySelectorAll('[data-mellow-testimonials]').forEach(initializeMellowTestimonials);

    if (!window.mellowTestimonialsEditorEventsBound) {
      window.mellowTestimonialsEditorEventsBound = true;

      document.addEventListener('shopify:section:load', (event) => {
        initializeMellowTestimonials(event.target.querySelector('[data-mellow-testimonials]'));
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (event.target.matches('.mellow-testimonials__card')) {
          event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq-hub"] && !Shopify.designMode) return;
  try {
    
  var applyFaqFilter = function(targetId, shouldScroll) {
    if (!targetId) return;

    var panels = document.querySelectorAll('[data-faq-panel]');
    var targetPanel = null;
    panels.forEach(function(panel) {
      if (panel.getAttribute('data-faq-panel') === targetId) {
        targetPanel = panel;
      }
    });
    if (!targetPanel) return;

    var filterFaq = function() {
      panels.forEach(function(panel) {
        var isSelected = panel.getAttribute('data-faq-panel') === targetId;
        panel.classList.toggle('is-hidden', !isSelected);
        panel.hidden = !isSelected;
      });

      document.querySelectorAll('[data-faq-filter]').forEach(function(item) {
        var isSelected = item.getAttribute('data-faq-filter') === targetId;
        item.classList.toggle('is-active', isSelected);
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      history.replaceState(null, '', '#' + targetId);
      if (shouldScroll) {
        targetPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    if (document.startViewTransition) {
      document.startViewTransition(filterFaq);
    } else {
      filterFaq();
    }
  };

  document.addEventListener('click', function(event) {
    var control = event.target.closest('[data-faq-filter]');
    if (!control) return;

    var targetId = control.getAttribute('data-faq-filter');
    if (!targetId) return;

    event.preventDefault();
    applyFaqFilter(targetId, true);
  }, true);

  var openHashFilter = function() {
    var targetId = window.location.hash.replace('#', '');
    if (targetId) {
      applyFaqFilter(targetId, false);
      return;
    }

    var control = document.querySelector('.mellow-faq-hub__category-list [data-faq-filter]');
    if (!control) return;

    applyFaqFilter(control.getAttribute('data-faq-filter'), false);
  };

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', openHashFilter);
  } else {
    openHashFilter();
  }

  } catch(e) { console.error(e); }
})();
})();
